import { ProfileType } from '../..';
import { BusinessDocType } from '../../../types';
import { WorkflowTemplateUIType } from '../../BusinessDocTypeSearch';
import { WorkflowActivityViewModel } from './WorkflowActivityViewModel';
import { WorkflowKeywordRoutingViewModel } from './WorkflowKeywordRoutingViewModel';

export interface WorkflowGroupUserViewModel {
    Id: number;
    UserId: number;
    WorkflowId: number;
    LastUpdateDate?: string;
    Rowversion?: string;
    ShortName: string;
    Name: string;
}

export interface WorkflowViewModel {
    Id: number;
    Name: string;
    RuleName: string;
    ShortName: string;
    WorkflowTemplateUI: WorkflowTemplateUIType;
    Version: number;
    BusinessDocType: BusinessDocType; // Supported value: Invoice
    BusinessDocType_US?: string;
    Reprocess: string | null;
    ProfileType: ProfileType; // Supported value: BuyerDestination
    ProfileType_US?: string;
    ProfileId: number;
    RuleOrdinal: number | null;
    EntryConditionLogicType: EntryConditionLogicType; // Supported value: Stored Procedure Name
    EntryConditionLogicType_US?: string;
    EntryConditionLogic: string;
    JavaScriptFilePath: string | null;
    Active: boolean;
    CustomData: string | null; // XML Data Structure
    ApprovalType: WorkflowApprovalType | null;
    ApprovalType_US?: string;
    WorkflowActivities: WorkflowActivityViewModel[];
    WorkflowGroupUsers: WorkflowGroupUserViewModel[];
    LastUpdateDate: string | null;
    Rowversion: string | null;
    CompanyId: number;
    WorkflowKeywordRoutings: WorkflowKeywordRoutingViewModel[];
}

export enum WorkflowApprovalType {
    CustomApproval = 1,
    UserManagerHierarchy = 2,
    UserGroupHierarchy = 3,
    UserGroupWithUserManagerFallback = 4,
    UserManagerWithUserGroupFallback = 5,
}

export enum EntryConditionLogicType {
    Undefined,
    SQLScript,
    SQLStatement,
    'Stored Procedure Name',
    VBScrip4,
    JavascriptCode,
}
